import React from 'react'

export default function Spinner() {
    return (
        <div class="spinner-border text-search-education" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    )
}

export function ButtonSpinner() {
    return (
        <button class="btn btn-search-education" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
        </button>
    )
}

